module.exports = __webpack_public_path__ + "fonts/AkkuratLL-BoldItalic.37596b4d.otf";